import { createLucideIcon, type IconNode } from "lucide-react";

/**
 * Glyphen, die lucide nicht hat — im selben 24er-Raster und mit derselben
 * Strichfuehrung gezeichnet, damit sie neben den lucide-Glyphen als eine
 * Familie lesen. `scripts/gen-app-icons.mjs` importiert diese Datei, damit die
 * PNG-Saetze aus derselben Form entstehen wie das Glyph im Kopf.
 */

// Janimo, der Begleiter: Kuppel mit zwei grossen Augen und Haartolle. Bewusst
// NICHT das Vollbild-Gesicht der PWA — das faellt aus der Icon-Familie (Betreiber 2026-10-19).
export const JANIMO_NODE: IconNode = [
  ["path", { d: "M4 14a8 8 0 0 1 16 0v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z", key: "kuppel" }],
  ["circle", { cx: "8.5", cy: "14.5", r: "2.25", key: "auge-l" }],
  ["circle", { cx: "15.5", cy: "14.5", r: "2.25", key: "auge-r" }],
  ["path", { d: "M12 6c0-2 1.2-3 3-3", key: "tolle" }],
];

export const Janimo = createLucideIcon("Janimo", JANIMO_NODE);

/** Name → Glyph, fuer Werkzeuge, die Glyphen per Name aufloesen. */
export const EIGENE_GLYPHEN = { Janimo } as const;
